<template>
    <div class="scc-container">
        <footer class="scc-app-footer">
            <div class="scc-app-footer__sub-container">
                <div class="scc-app-footer__sub-container-left">
                    <img v-if="gameLogo" class="scc-app-footer__game-logo" :src="gameLogo" alt="Logo" />
                </div>
                <div class="scc-app-footer__sub-container-right">
                    <div v-if="socials && socials.length > 0" class="scc-app-footer__socials">
                        <template v-for="(social, i) in socials">
                            <a :key="i" :href="social.link" target="_blank" @click="logSocial(social)">
                                <img :src="social.image" :alt="social.name" />
                            </a>
                        </template>
                    </div>
                    <div v-if="smallLinks && smallLinks.length > 0" class="scc-app-footer__small-links">
                        <template v-for="(link, i) in smallLinks">
                            <SccLink
                                v-if="link.link"
                                :key="link.link + i"
                                class="scc-app-footer__small-link kwf-note"
                                :to="link.link"
                            >
                                {{ link.name }}
                            </SccLink>
                            <span
                                v-else-if="link.name.includes('instellingen')"
                                :key="i"
                                class="scc-app-footer__small-link kwf-note"
                                @click="openCookieSettings"
                            >
                                {{ link.name }}
                            </span>
                            <span v-else :key="i" class="scc-app-footer__small-link kwf-note">{{ link.name }}</span>
                        </template>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import './app-sub-footer.scss';
import SccLink from '../global/SccLink';

export default {
    name: 'AppSubFooter',
    components: { SccLink },
    __editor: {
        fields: {
            gameLogo: {
                widget: 'media',
            },
            smallLinks: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        name: {
                            widget: 'text',
                        },
                        link: {
                            widget: 'text',
                        },
                    },
                },
            },
        },
    },
    props: {
        gameLogo: {
            type: String,
            default: null,
        },
        socialMedia: {
            type: Object,
            default() {
                return {
                    facebook: false,
                    twitter: false,
                    instagram: false,
                    linkedin: false,
                    youtube: false,
                };
            },
        },
        smallLinks: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    computed: {
        socials() {
            let socials = [];
            let socialArray = Object.entries(this.socialMedia).map(([key, value]) => ({ key, value }));

            socialArray.forEach(social => {
                socials.push({
                    name: `${social.key}`,
                    image: require(`@/assets/icons/${social.key}.svg`),
                    link: social.value,
                });
            });
            return socials;
        },
    },
    methods: {
        openCookieSettings() {
            window?.dsmConsent?.showPopup();
        },
        logSocial(social) {
            const dimensions = { social_name: social.name, social_action: 'redirect' };
            this.$logger?.logSocialInteraction(dimensions);
        },
    },
};
</script>
